export var COUNTRIES = /*#__PURE__*/['CN',
// 中国
'ID',
// 印尼
'TH',
// 泰国
'VN',
// 越南
'MY',
// 马来西亚
'PH',
// 菲律宾
'SG',
// 新加坡

'FR',
// 法国
'ES',
// 西班牙
'PT',
// 葡萄牙

'PK',
// 巴基斯坦
'LK',
// 斯里兰卡
'MM',
// 缅甸
'BD',
// 孟加拉
'NP' // 尼泊尔
];
export var LZD_COUNTRIES = /*#__PURE__*/['ID', 'TH', 'VN', 'MY', 'PH', 'SG'];
export var DRZ_COUNTRIES = /*#__PURE__*/['PK', 'LK', 'MM', 'BD', 'NP'];
export var MRV_COUNTRIES = /*#__PURE__*/['ES'];
export var MAIN_LANG_MAP = /*#__PURE__*/{
  CN: 'zh',
  // 中国
  SG: 'en',
  // 新加坡
  MY: 'ms',
  // 马来西亚
  TH: 'th',
  // 泰国
  VN: 'vi',
  // 越南
  ID: 'in',
  // 印尼
  PH: 'en',
  // 菲律宾

  FR: 'fr',
  // 法国
  ES: 'es',
  // 西班牙
  DE: 'de',
  // 德国
  IT: 'it',
  // 意大利
  PT: 'pt',
  // 葡萄牙

  // 在当前业务中，主要以英语为主
  PK: 'en',
  // 巴基斯坦
  LK: 'en',
  // 斯里兰卡
  MM: 'en',
  // 缅甸
  BD: 'en',
  // 孟加拉
  NP: 'en' // 尼泊尔
};
export var FLAG_MAP = /*#__PURE__*/{
  CN: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/CN.svg',
  SG: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/SG.svg',
  MY: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/MY.svg',
  TH: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/TH.svg',
  VN: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/VN.svg',
  ID: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/ID.svg',
  PH: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/PH.svg',
  US: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/US.svg',
  FR: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/FR.svg',
  ES: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/ES.svg',
  DE: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/DE.svg',
  IT: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/IT.svg',
  PT: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/PT.svg',
  RU: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/RU.svg',
  PK: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/PK.svg',
  LK: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/LK.svg',
  MM: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/MM.svg',
  BD: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/BD.svg',
  NP: 'https://g.alicdn.com/lazada/lib/0.1.0/flags/NP.svg'
};
export var FLAG_EMOJI_MAP = /*#__PURE__*/{
  CN: '🇨🇳',
  // 中国
  SG: '🇸🇬',
  // 新加坡
  MY: '🇲🇾',
  // 马来西亚
  TH: '🇹🇭',
  // 泰国
  VN: '🇻🇳',
  // 越南
  ID: '🇮🇩',
  // 印尼
  PH: '🇵🇭',
  // 菲律宾

  US: '🇺🇸',
  // 美国
  FR: '🇫🇷',
  // 法国
  ES: '🇪🇸',
  // 西班牙
  DE: '🇩🇪',
  // 德国
  IT: '🇮🇹',
  // 意大利
  PT: '🇵🇹',
  // 葡萄牙
  RU: '🇷🇺',
  // 俄罗斯

  PK: '🇵🇰',
  // 巴基斯坦
  LK: '🇱🇰',
  // 斯里兰卡
  MM: '🇲🇲',
  // 缅甸
  BD: '🇧🇩',
  // 孟加拉
  NP: '🇳🇵' // 尼泊尔
};